export interface Category {
  id?: number;
  key: string;
  name: string;
}

export interface SpatialLayer {
  id: number | string;
  key: string;
  title?: string;
  name: string;
  source: string;
  isChecked: boolean;
  category?: Category;
  auto_display?: boolean;
  isHovered?: boolean;
  service_type?: number;
}

export interface Sublayer {
  id?: number | string;
  sublayerID?: number | string;
  sublayerName?: string;
  title?: string;
  display_name?: string;
  gis_service_url?: string;
}

export interface GISSupplementalLayer {
  id: number | string;
  display_name: string;
  gis_service_url?: string;
  sublayers?: Sublayer[];
  service_type?: number;
  layerIndex?: number;
}

// Union type for the layer prop since it can be either type
export type Layer = SpatialLayer | GISSupplementalLayer;

export interface LayerCheckboxProps {
  layer: Layer;
  isDisabled: boolean;
  isGISSupplementalLayer: boolean;
}

// Type for GIS Service from activeGISServices array
export interface GISService {
  id: number | string;
  display_name?: string;
  [key: string]: unknown;
}

// Redux state interfaces
export interface MapCardData {
  layerData?: {
    source?: string;
  };
}

export interface MapCardState {
  mapCardData?: MapCardData | null;
}

export interface IrpState {
  irpVersion: number | string;
}

export interface SinatraState {
  irp: IrpState;
}

export interface ActiveSublayer {
  sublayerID: number | string;
}

export interface GISServicesState {
  activeSupplementalServicesSublayers: ActiveSublayer[];
  activeBasemapServiceSublayers: ActiveSublayer[];
}

export interface RootState {
  mapCard?: MapCardState;
  sinatra: SinatraState;
  gisServices: GISServicesState;
}

// Type guards to help distinguish between layer types
export const isSpatialLayer = (layer: Layer): layer is SpatialLayer => {
  return 'isChecked' in layer && 'key' in layer;
};

export const isGISLayer = (layer: Layer): layer is GISSupplementalLayer => {
  return 'display_name' in layer;
};
